export default __webpack_public_path__ + "static/media/loading.a5d43505.svg";